import { featureFlags } from "../config/featureFlags.config";
import { FeatureFlagKey } from "../types/featureFlags.types";

// Flags are static for the lifetime of the build (see featureFlags.config.ts), so this is just a
// thin, component-friendly wrapper - it doesn't subscribe to anything or trigger re-renders.
export const useFeatureFlag = (key: FeatureFlagKey): boolean => featureFlags[key];

export const useFeatureFlags = (): typeof featureFlags => featureFlags;
